import React from 'react';

import withFilterForm from './base/withFilterForm';
import BaseSearchFilter from './base/BaseSearchFilter';

export default withFilterForm(props => (
    <BaseSearchFilter {...props} disableMobileCollapse={true} />
));
